import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './app/App';
import { WebSocketProvider } from './stores/websocketContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <WebSocketProvider
      remoteServerUrl={process.env.REACT_APP_SERVER_URL}
      jwtToken={process.env.REACT_APP_JWT}
    >
      <App />
    </WebSocketProvider>
  </React.StrictMode>
);
